import People from '../scenes/People';
import AdminUsers from '../scenes/AdminUsers';
import Home from '../scenes/Home';
import Files from '../scenes/Files';
import MyProfile from "../scenes/MyProfile";
import MembershipAnnuityPayments from "../scenes/AnnuityPayments/MembershipAnnuityPayments";
import IHSAnnuityPayments from "../scenes/AnnuityPayments/IHSAnnuityPayments";
import MyAnnuityPayments from "../scenes/MyAnnuityPayments";
import Directory from "../scenes/MailManager/Directory";
import Tags from "../scenes/MailManager/Tags";
import SendEmail from "../scenes/MailManager/SendEmail"
import EmailBin from "../scenes/MailManager/EmailBin"
import Congresses from "../scenes/Congresses"
import Events from '../scenes/Events'
import Certificates from "../scenes/Certificates"
import MembersReports from "../scenes/Reports/MembersReports";
import CongressesReports from "../scenes/Reports/CongressesReports";
import PaymentsReports from "../scenes/Reports/PaymentsReports";
import MyCertificates from "../scenes/MyCertifciates";
import PublicInGral from '../scenes/PublicInGral/PublicInGral';

export default (security) => {

    window.security = security;
    let routes = [];

    if (security.isMember()) {
        routes = [
            {path: "/me", name: "Mi perfil", component: MyProfile, icon: "fa fa-user"},
            {path: "/certificates", name: "Constancias", component: MyCertificates, icon: "fa fa-bookmark"}
        ];
        if (security.core.canViewLibrary()) {
            routes = [...routes, {path: "/files", name: "Biblioteca", component: Files, icon: "fa fa-university"}];
        }
        routes = [...routes, {path: "/payments", name: "Mis pagos", component: MyAnnuityPayments, icon: "fa fa-credit-card"}];
    }

    if (security.isSuperAdmin()) {
        routes = [
            {path: "/", name: "Inicio", component: Home, hidden: true},
            {path: "/files", name: "Biblioteca", component: Files, icon: "fa fa-university"}
        ];
    }

    if (security.core.canManageAdminUsers()) {
        routes = [...routes,
            {path: "/users", name: "Administrativos", component: AdminUsers, icon: "fa fa-user"}
        ];
    }

    if (security.core.canListMembers()) {
        routes = [...routes,
            {path: "/members", name: "Miembros", component: People, icon: "fa fa-user-md"},
            {path: "/ihs-members", name: "Miembros IHS", component: People, icon: "fa fa-user-md"}
        ];
    }

    if (security.core.canManageGeneralPeople()) {
        routes = [...routes, ...[
            {path: "/gral-public", name: "Público en gral.", component: PublicInGral, icon: "fa fa-users"}
        ]]
    }

    if (security.core.canSeePayments() || security.core.canManagePayments()) {
        routes = [...routes, ...[
            {
                collapse: true,
                name: "Pagos de anualidades",
                state: "annuityPayments",
                icon: "fa fa-credit-card",
                views: [
                    {
                        path: "/payments/membership-payments",
                        name: "Pagos de membresías",
                        icon: "fa fa-credit-card",
                        mini: "M",
                        component: MembershipAnnuityPayments
                    },
                    {
                        path: "/payments/ihs-payments",
                        name: "Pagos de IHS",
                        icon: "fa fa-credit-card",
                        mini: "I",
                        component: IHSAnnuityPayments
                    }]
            }
        ]
        ]
    }

    if (security.core.canSeeReports()) {
        routes = [...routes, ...[
            {
                collapse: true, name: "Reportes", state: "reports", icon: "fa fa-list-alt", views: [
                    {
                        path: "/reports/membersReports",
                        name: "Reportes de miembros",
                        icon: "fa fa-list-alt",
                        mini: "RM",
                        component: MembersReports
                    },
                    {
                        path: "/reports/congressesReports",
                        name: "Reportes de congresos",
                        icon: "fa fa-list-alt",
                        mini: "RC",
                        component: CongressesReports
                    },
                    {
                        path: "/reports/paymentsReports",
                        name: "Reportes de pagos",
                        icon: "fa fa-list-alt",
                        mini: "RP",
                        component: PaymentsReports
                    },
                ]
            }
        ]];
    }

    if (security.core.canSendEmails()) {
        routes = [...routes, ...[
            {
                collapse: true, name: "Gestor de Correo", state: "mailManager", icon: "fa fa-envelope", views: [
                    {
                        path: "/mailManager/directory",
                        name: "Directorio",
                        icon: "fa fa-envelope",
                        mini: "D",
                        component: Directory
                    },
                    {
                        path: "/mailManager/tags",
                        name: "Grupos de correo",
                        icon: "fa fa-tag",
                        mini: "G",
                        component: Tags
                    },
                    {
                        path: "/mailManager/sendEmail",
                        name: "Enviar correo",
                        icon: "fa fa-envelope",
                        mini: "M",
                        component: SendEmail
                    },
                    {
                        path: "/mailManager/emails",
                        name: "Correos",
                        icon: "fa fa-envelope",
                        mini: "E",
                        component: EmailBin
                    },]
            }
        ]];
    }


    if (security.core.canManageCongresses()) {
        routes = [...routes, ...[
            {path: "/congresses", name: "Congresos", component: Congresses, icon: "fa fa-handshake-o"},
        ]]
    }

    if (security.core.canManageEvents()) {
        routes = [...routes, ...[
            {path: "/events", name: "Eventos y talleres", component: Events, icon: "fa fa-calendar-check-o"},
        ]]
    }

    if (security.core.canManageCertificates()) {
        routes = [...routes, ...[
            {path: "/certificates", name: "Constancias", component: Certificates, icon: "fa fa-id-card-o"}
        ]]
    }

    if (security.isMember()) {
        routes = [...routes, ...[
            {path: "/", to: "/me", redirect: true}
        ]]

    }
    return routes;

}


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/services/routes.js